import * as d3 from "d3";
import $ from "jquery";
import {
  deepCopy,
  genericXHRErrorHandler,
  getAuthHeader,
  removeDeviceFromCanPutDifferentDeviceByRoomIdCache,
  removeProgressBar,
  setProgressBarState,
  startLoading,
  stopLoading,
  toastError,
  toastSuccess,
  whenAll
} from "src/components/Planner/controller";
import {deviceProvider} from "src/components/Planner/planner/DeviceProvider";
import {
  placeDevice,
  redrawDevice,
  redrawDevices
} from "src/components/Planner/planner/deviceDrawing";
import {
  showDragAndDropOverlay
} from "src/components/Planner/planner/draganddrop";
import {
  refreshFloorView
} from "src/components/Planner/planner/plannerCacheInvalidation";
import {
  isDevLightingSwitch,
  isDevShadingType,
  redrawGroups
} from "src/components/Planner/planner/grouping";
import {plannerHistoryHelper} from "src/components/Planner/planner/history";
import {
  getMeasurementsOfDevice,
  getMeasurementsOfSerial,
  removeDeviceFromMeasuresLocal
} from "src/components/Planner/planner/measurement";
import {
  closeAddModNoteModal,
  redrawNotes
} from "src/components/Planner/planner/notes";
import {
  d3DevRotatedRectPolygon,
  dataFromDeviceD,
  getDeviceCoordinates,
  getDevicePositionCenter,
  getDevicesD3Style,
  isPlannerMetric,
  moveEnframedDevsToRoom,
  processDeletedD3Devs,
  removeDeviceFromCacheLocal,
  removeDeviceFromGroupsLocal,
  unHighlight,
  updateDev
} from "src/components/Planner/planner/planner";
import {PlannerGlobals} from "src/components/Planner/planner/planner-globals";
import {
  getDColsNum,
  getDRowsNum,
  SERIAL_SPACING
} from "src/components/Planner/planner/serial-layout";
import {
  getSerialCenterPos,
  getSerialConnectedPair,
  getSerialConnectionForSerialId,
  getSerialConnectionProps
} from "src/components/Planner/planner/serialConnections";
import {
  ajaxSetSerialProps,
  getRotatedSerialCorners,
  getSerialD,
  getSerialHeightForPNID,
  removeDeviceFromSerial
} from "src/components/Planner/planner/serialConnections-dom";
import {
  getD3DevTopCenter,
  getDeviceById,
  getDistinctGroupsOfDevs,
  getDistinctSerialConnectionsOfDevs,
  getGroupsOfDevice,
  getNote,
  getNoteById,
  getRoomById,
  getSerialById,
  getSerialOfDeviceId,
  getSerObj,
  isDevMergedWithSerials,
  isPointSnapped,
  isRoomOutside,
  serialRealLength,
  uDev,
  UDevGlobals
} from "src/components/Planner/planner/uDev";
import {
  doesDeviceFitRoom,
  P_numtoxy,
  snapDeviceToWall,
  uMath
} from "src/components/Planner/planner/uMath";
import {ROOT_URI} from "src/utils/constants";
import {inchToCm} from "src/utils/imperialConverter";
import {ts} from "src/utils/translate";

export function modDevNote(dev, color, text, callback) {
  uDevDOM.postItAjax.modify(dev.noteId, color, text, function (resp) {
    toastSuccess(resp.message);
    dev.noteTxt = text;
    dev.noteColor = color;
    closeAddModNoteModal();
    if (PlannerGlobals.notes_on) {
      redrawDevice(dev.deviceId);
    }
    stopLoading();
    if (typeof callback === "function") {
      callback(dev);
    }
  }, function (resp) {
    genericXHRErrorHandler(resp);
    if (typeof callback === "function") {
      callback(false);
    }
  });
}

/**
 *
 * @param {number} deviceId
 * @param {string} text
 * @param {string} color
 * @param {function} callback
 */
export function sendDevNoteAuto(deviceId, text, color, callback) {
  var dev = getDeviceById(deviceId);
  if (!dev) {
    if (typeof callback === "function") {
      callback(false);
    }
  }

  var strId = deviceId + "";
  var type = strId.indexOf('C_') === 0 ? 3 : 2;

  sendDevNote(type, color, text, strId, dev, function (dev) {
    if (dev) {
      if (typeof callback === "function") {
        callback(dev);
      }
    }
    else {
      if (typeof callback === "function") {
        callback(false);
      }
    }
  });
}

export function sendDevNote(type, color, text, strId, dev, callback) {
  uDevDOM.postItAjax.sendNew({
    note_type: type,
    color: color,
    note: text,
    floor_id: PlannerGlobals.plannerFloorId,
    plan_object_id: +strId.replace('C_', ''),
  }, function (resp) {
    dev.noteId = resp.id;
    dev.hasNote = true;
    dev.noteTxt = text;
    dev.noteColor = color;
    closeAddModNoteModal();
    if (PlannerGlobals.notes_on) {
      redrawDevice(dev.deviceId);
    }
    stopLoading();
    if (typeof callback === "function") {
      callback(dev);
    }
  }, function (resp) {
    genericXHRErrorHandler(resp);
    if (typeof callback === "function") {
      callback(false);
    }
  });
}

export function deleteDevNote(dev, callback) {
  dev.noteGhost = true;
  uDevDOM.postItAjax.delete(dev.noteId, function (resp) {
    dev.noteGhost = false;
    dev.hasNote = false;
    dev.noteId = null;
    dev.noteTxt = null;
    dev.noteColor = null;
    if (typeof callback === "function") {
      callback(true);
    }
  }, function (resp) {
    dev.noteGhost = false;
    genericXHRErrorHandler(resp);
    if (typeof callback === "function") {
      callback(false);
    }
  });
}

export function modSoleNote(note, color, txt, callback) {
  uDevDOM.postItAjax.modify(note.note_id, color, txt, function (resp) {
    /* toastSuccess(resp.message); */
    note.text = txt;
    note.color = color;
    redrawNotes();
    if (typeof callback === "function") {
      callback(note);
    }
  }, function (resp) {
    genericXHRErrorHandler(resp);
    if (typeof callback === "function") {
      callback(false);
    }
  });
}

/**
 *
 * @param {*} x
 * @param {*} y
 * @param {*} text
 * @param {*} color
 * @param {function(Note)} callback
 */
export function sendSoleNote(x, y, text, color, callback) {
  var newFakeId = +new Date();
  var newNote = {
    note_id: newFakeId, x, y, text, color, ghost: true
  };
  PlannerGlobals.notes.push(newNote);
  if (PlannerGlobals.notes_on) {
    redrawNotes();
  }
  uDevDOM.postItAjax.sendNew({
    x: x,
    y: y,
    floor_id: PlannerGlobals.plannerFloorId,
    color: color,
    note: text,
    note_type: 1

  }, function (resp) {
    newNote.note_id = resp.id;
    newNote.ghost = false;
    redrawNotes();
    if (typeof callback === "function") {
      callback(newNote);
    }
    showDragAndDropOverlay();
  }, function (resp) {
    PlannerGlobals.notes = PlannerGlobals.notes.filter(function (note) {
      return note.note_id !== newFakeId;
    });
    redrawNotes();
    genericXHRErrorHandler(resp);
    if (typeof callback === "function") {
      callback(false);
    }
  });
}

export function deleteSoleNote(noteId, callback) {
  var note = getNoteById(noteId);
  if (note) {
    note.ghost = true;
    uDevDOM.postItAjax.delete(noteId, function (resp) {
      note.ghost = false;
      PlannerGlobals.notes = PlannerGlobals.notes.filter(function (note) {
        return note.note_id !== noteId;
      });
      if (typeof callback === "function") {
        callback(true);
      }
      showDragAndDropOverlay();
    }, function (resp) {
      note.ghost = false;
      genericXHRErrorHandler(resp);
      if (typeof callback === "function") {
        callback(false);
      }
    });
  }
  else {
    callback(true);
  }
}

/**
 *
 * @param {Device} dev
 */
export function getProductOfDevice(dev) {
  var node = deviceProvider.getDeviceHelper(dev);
  if (node === null) {
    node = $.extend(true, {}, dev);
    node.text = "";
    node.id = "product_FAKE";
  }
  // Legacy placeDevice reads `parent` to derive category_id; V2 DeviceProvider doesn't include it.
  if (node && typeof node === "object" && !node.parent && dev && dev.category_id != null) {
    node = Object.assign({}, node, { parent: 'category_' + dev.category_id });
  }
  return node;

}

export function getProductById(pnid) {
  const product = deviceProvider.getDeviceByProductNameId(pnid);
  if (!product) {
    return null;
  }
  // Legacy placeDevice reads `parent` ('category_<id>') to derive category_id; clone so it's mutable too.
  const categoryId = deviceProvider.getCategoryOfProductNameId(pnid);
  return Object.assign({}, product, { parent: 'category_' + categoryId });
}

/**
 *
 * @param {Device[]} removeDevs
 */
export function removeDevicesParallel(removeDevs, onDevRemove) {
  var defs = [];

  removeDevs.forEach(function (dev) {
    var def = removeDevicePure(dev.deviceId);
    defs.push(def);
    def.done(function () {
      if (typeof onDevRemove === "function") {
        onDevRemove();
      }
    });
  });

  return whenAll(defs);
}

/**
 * Remove the devices recursively and update progress bar
 * @param {Device[]} removeDevs
 * @param {function} callback
 * @returns {JQuery.Deferred<any,any,any>}
 */
export function removeDevices(removeDevs, callback, dontRefreshTree = false) {
  var prom = $.Deferred();
  PlannerGlobals.plannerIsRemovingDevices = true;
  startLoading();
  setProgressBarState(0);
  var removeds = 0;
  removeDevicesRecursive(removeDevs, removeDevs.length - 1, function (res) {
    PlannerGlobals.plannerIsRemovingDevices = false;
    stopLoading();
    removeProgressBar();
    if (!dontRefreshTree) {
      refreshFloorView();
    }
    if (typeof callback === "function") {
      callback(res);
    }
    if (res) {
      prom.resolve();
    }
    else {
      prom.reject();
    }
  }, function () {
    removeds++;
    setProgressBarState(removeds / removeDevs.length * 100);
  });
  return prom;
}

/**
 *
 * @param {Device[]} removeDevs
 * @param {number} idx
 * @param {function} callback
 * @param {function} onDevRemove
 */
export function removeDevicesRecursive(removeDevs, idx, callback, onDevRemove) {
  if (idx === -1) {
    if (typeof callback === "function") {
      callback(true);
    }
  }
  else {
    var def = removeDevicePure(removeDevs[idx].deviceId);
    def.then(function () {
      if (typeof onDevRemove === "function") {
        onDevRemove();
      }
      removeDevicesRecursive(removeDevs, idx - 1, callback, onDevRemove);
    });
    def.catch(function (a) {
      toastError(a);
      if (typeof callback === "function") {
        callback(false);
      }
    });
  }
}

export function removeDevicePure(deviceId) {
  var def = $.Deferred();
  unHighlight();
  $('.device-tool').hide();
  $('#rotate-tool').hide();
  //find out if the device is stored locally (it should be)
  var deleteIndex = PlannerGlobals.devices.findIndex(function (device) {
    return device.deviceId == deviceId;
  });
  const origiDev = PlannerGlobals.devices[deleteIndex];
  //if it is, send a request to the server
  if (deleteIndex != -1) {
    origiDev.ghost = true;
    removeDeviceFromCanPutDifferentDeviceByRoomIdCache(origiDev.roomId, origiDev.product_name_id);
    var isCabinet = 'type' in origiDev && origiDev.type.toString().indexOf("cabinet") != -1;
    var isCustom = origiDev.deviceId.toString().indexOf("C_") == 0;
    var sendURL = ROOT_URI + '/device';
    var sendData = { plan_object_id: +deviceId };

    if (isCabinet) {
      sendURL = ROOT_URI + '/floor/additional-item';
      sendData = { additional_item_id: +deviceId.toString().replace('S_', '') };
    }

    if (isCustom) {
      sendURL = ROOT_URI + '/user-custom-items/room-user-custom-item';
      sendData = { room_user_custom_item_id: +deviceId.toString().replace("C_", "") };
    }

    getAuthHeader(function (header) {
      $.ajax({
        headers: header,
        url: sendURL,
        type: 'DELETE',
        dataType: 'JSON',
        data: sendData,
        success: function (response) {
          origiDev.ghost = false;
          origiDev.deleted = true;
          removeDeviceFromGroupsLocal(deviceId);
          removeDeviceFromSerial(deviceId, false, true);
          removeDeviceFromMeasuresLocal(deviceId);
          removeDeviceFromCacheLocal(origiDev);

          PlannerGlobals.devices = PlannerGlobals.devices.filter(function (device) {
            return device.deviceId != deviceId;
          });


          def.resolve();
        },
        error: function (response) {
          origiDev.ghost = false;
          if (typeof response === "object" && response &&
              typeof response.responseJSON === "object" && response.responseJSON &&
              response.responseJSON.message) {
            def.reject(response.responseJSON.message);
          }
          else {
            def.reject(ts('offline', 'offline'));
          }
        }
      });
    });
  }
  else {
    console.debug("Tried to remove non-existent deviceId", deviceId);
    def.reject();
  }
  return def;
}

/**
 * This is for checking if a device is NOT SERIALIZED.
 * @param {number} pnid
 */
export function isDevSingle(pnid) {
  let node = deviceProvider.getDeviceByProductNameId(pnid);
  if (!node) {
    return true;
  }
  return !node.serializable;
}

export function canBeDevMerged(device) {

  // console.log('canBeDevMerged');

  let canBeDevMerged = false;

  if (device.mergeable === true) {
    // console.log('canBeDevMerged1');
    PlannerGlobals.devices.forEach((dev) => {
      if (dev.mergeable === true) {
        // console.log('mergeable');
        if (dev.deviceId !== device.deviceId) {
          // console.log('nem egyenlő');
          if (device.product_name_id === dev.product_name_id) {
            // console.log('ugyanaz a két device name');
            if (uMath.polygonsIntersect(getDeviceCoordinates(dev, 0.15), getDeviceCoordinates(device, 0.15))) {
              // console.log('koordináta csekk jó');
              canBeDevMerged = true;
            }
            else {
              if(device.category_id === 1) {
                canBeDevMerged = true;
              }
            }
          }
        }
      }

    });
  }

  return canBeDevMerged;
}

/**
 * visszaadja azt az eszközt amire rádobtuk a másik eszközt
 *
 * @param device
 * @returns {null}
 */
export function getMergedDevice(device) {

  let mergeDevice = null;

  if (device.mergeable === true) {
    PlannerGlobals.devices.forEach((dev) => {
      if (
          dev.mergeable === true // csak a mergelhetők
          && dev.deviceId !== device.deviceId // nem önmaga
          && device.product_name_id === dev.product_name_id // csak azonos termékek
          && uMath.polygonsIntersect(getDeviceCoordinates(dev, 0.15), getDeviceCoordinates(device, 0.15)) // kordináta ellenőrzés
      ) {
        mergeDevice = dev;
      }
    });
  }

  return mergeDevice;
}

export function removeDevAllOccurrences(deviceId, onlyRoom, callback) {
  var dev = getDeviceById(deviceId);
  if (!dev) {
    return;
  }
  /**
   * @type {Device[]}
   */
  var devsToDel = [];
  var sourceDevs = PlannerGlobals.devices;
  if (onlyRoom) {
    sourceDevs = sourceDevs.filter(function (x) { return x.roomId === dev.roomId });
  }

  if (typeof deviceId === "number") {
    deviceId = deviceId.toString();
  }

  if (typeof deviceId === "string") {
    if (deviceId.indexOf('S_') === 0) {
      devsToDel = [dev];
    }
    else if (deviceId.indexOf('C_') === 0) {
      devsToDel = sourceDevs.filter(function (x) { return x.user_custom_item_id == dev.user_custom_item_id; });
    }
    else {
      devsToDel = sourceDevs.filter(function (x) { return x.product_name_id == dev.product_name_id; });
    }
  }
  else {
    console.log('not string devid', deviceId);
  }

  removeTheseDevs(devsToDel, callback);
}

export function removeTheseDevs(devsToDel, callback) {
  var devsToDelClone = deepCopy(devsToDel);

  var removedGrps = deepCopy(getDistinctGroupsOfDevs(devsToDel));
  var removedMeasurements = devsToDelClone.map(function (dev) { return getMeasurementsOfDevice(dev.deviceId); })
  .reduce(function (p, c) { return p.concat(c); }, []);

  var removedSerials = {};
  devsToDelClone.forEach(function (dev) {
    var ser = getSerialOfDeviceId(dev.deviceId);
    if (ser) {
      dev.alone = false;
      dev.targetSerialId = ser.id;
      dev.serHeight = ser.height;
      dev.serDirection = ser.direction;
      if (!(ser.id in removedSerials)) {
        removedSerials[ser.id] = [];
      }
      removedSerials[ser.id].push(dev.deviceId);
    }
    else {
      dev.alone = true;
      dev.targetSerialId = null;
    }
  });
  for (var key in removedSerials) {
    var origiSer = getSerialById(key);
    if (origiSer.deviceIds.length === removedSerials[key].length) {
      // serial is completely deleted
      var firstDevOfSer = devsToDelClone.find(function (dev) { return dev.targetSerialId === origiSer.id; });
      if (firstDevOfSer) {
        firstDevOfSer.alone = true;
      }
      removedMeasurements = removedMeasurements.concat(getMeasurementsOfSerial(origiSer.id));
    }
  }

  var affectedSerials = {};
  var affectedSerialConnections = {};

  devsToDel.forEach(function (dev) {
    var ser = getSerialOfDeviceId(dev.deviceId);
    if (ser && ser.deviceIds.length > 0) {
      var firstDev = getDeviceById(ser.deviceIds[0]);
      if (firstDev) {
        affectedSerials[ser.id] = {
          len: serialRealLength(ser),
          firstDevX: firstDev.x,
          firstDevY: firstDev.y,
          topCenter: getD3DevTopCenter(getTopD3DevForSerial(ser.id))
        };
        const conn = getSerialConnectionForSerialId(ser.id);
        if (conn) {
          affectedSerialConnections[conn.id] = conn;
          const connPair = getSerialConnectedPair(ser.id);
          if (connPair) {
            affectedSerials[ser.id].connPairId = connPair.id;
          }
        }
      }
    }
  });

  var deletedSerialConnections = Object.values(affectedSerialConnections);

  removeDevices(devsToDel, function () {
    for (var key in affectedSerials) {
      const currAffSer = affectedSerials[key];
      var ser = getSerialById(+key);
      let connPair = currAffSer.connPairId ? getSerialById(currAffSer.connPairId) : null;
      if (!ser || !ser.deviceIds.length && connPair && connPair.deviceIds.length) {
        ser = connPair;
        connPair = null;
      }
      if (ser && ser.deviceIds.length > 0) {
        if (connPair && (!connPair.deviceIds.length || connPair.id in affectedSerials)) {
          connPair = null;
        }
        const wasSnapped = isPointSnapped(currAffSer.topCenter);
        if (wasSnapped) {
          const currD3Elem = getTopD3DevForSerial(ser.id);
          const cols = getDColsNum(currD3Elem);
          const rows = getDRowsNum(currD3Elem);
          const newSnapped = snapDeviceToWall(currAffSer.topCenter, PlannerGlobals.DEVICE_SIZE * 10, cols, false,
              undefined, undefined, undefined, undefined, rows);
          if (newSnapped) {
            const pos = {
              x: newSnapped.point.x,
              y: newSnapped.point.y,
              angle: newSnapped.rotation,
              roomId: newSnapped.room.id
            }
            setAndSendSerialPosition(ser.id, pos);
            if (connPair) {
              setAndSendSerialPosition(connPair.id, pos);
            }
          }
        }
        else {
          var serialOrigiLength = currAffSer.len;
          var serialNewLength = serialRealLength(ser);
          if (serialNewLength < serialOrigiLength) {
            var diff = serialOrigiLength - serialNewLength;
            var firstDev = getDeviceById(ser.deviceIds[0]);
            if (ser.direction === "horizontal") {
              firstDev.x = currAffSer.firstDevX + diff * (PlannerGlobals.DEVICE_SIZE / 2 + SERIAL_SPACING / 2);
            }
            else {
              firstDev.y = currAffSer.firstDevY + diff * (PlannerGlobals.DEVICE_SIZE / 2 + SERIAL_SPACING / 2);
            }
            firstDev.angle = ser.angle;
            setAndSendSerialPosition(ser.id, firstDev);
            if (connPair) {
              setAndSendSerialPosition(connPair.id, firstDev);
            }
          }
        }
      }
    }

    redrawDevices();

    if (typeof callback === "function") {
      callback(devsToDelClone, removedGrps, removedMeasurements, deletedSerialConnections);
    }
  });
}

/**
 *
 * @param {number} srcDeviceId Device ID to change (only normal dev allowed, no custom or cabinet)
 * @param {number} targetProductId target PNID
 * @param {boolean} targetIdIsCustom
 * @param {Point?} forcedPosition
 * @param {boolean} noRedraw Prevent device redraw in this function. You have to redraw manually after calling function!
 * @param {boolean} disableGrouping changing the device doesnt place it back into its groups
 * @param {{id: number, height: number, direction: 'horizontal' | 'vertical', x, y, angle}} targetSerialParams
 */
export function changeDevice(srcDeviceId, targetProductId, targetIdIsCustom = false, forcedPosition = null, noRedraw = false, disableGrouping = false, targetSerialParams = null) {
  var promise = $.Deferred();
  var srcDev = getDeviceById(srcDeviceId);
  var pnidKey = targetIdIsCustom ? 'user_custom_item_id' : 'product_name_id';
  var productPrefix = targetIdIsCustom ? 'user_custom_item_' : 'product_';
  var productType = targetIdIsCustom ? 'custom_device' : 'device';
  if (!srcDev || srcDev[pnidKey] == targetProductId || UDevGlobals.devIsChangingTo[srcDeviceId] === targetProductId) {
    promise.resolve(false);
    return promise;
  }

  let tarProduct;
  if (targetIdIsCustom) {
    const myProduct = deviceProvider.getMyProduct(targetProductId);
    if (myProduct) {
      const iconDataUrl = myProduct.icon_svg ? `data:image/svg+xml;base64,${btoa(myProduct.icon_svg)}` : '';
      tarProduct = Object.assign({}, myProduct.userCustomItem, {
        icon: iconDataUrl,
        image: iconDataUrl,
      });
    }
  } else {
    tarProduct = deviceProvider.getDeviceByProductNameId(targetProductId);
  }
  if (!tarProduct) {
    promise.resolve(false);
    return promise;
  }

  var devClone = Object.assign({}, srcDev);
  devClone[pnidKey] = targetProductId;

  UDevGlobals.devIsChangingTo[srcDeviceId] = targetProductId;
  UDevGlobals.devIsChangingToObj[srcDeviceId] = devClone;

  srcDev.ghost = true;
  redrawDevice(srcDev.deviceId);

  var groupingAllowed = tarProduct.groupable && srcDev.is_loxone === tarProduct.is_loxone && !disableGrouping;
  if (isDevShadingType(srcDev) && !isDevShadingType(tarProduct)) {
    groupingAllowed = false;
  }
  if (isDevLightingSwitch(srcDev) && !isDevLightingSwitch(tarProduct)) {
    groupingAllowed = false;
  }

  var needToCreateNewSerial = targetSerialParams && !getSerialById(targetSerialParams.id);
  var origiSerial = targetSerialParams ? getSerialById(targetSerialParams.id) : getSerialOfDeviceId(srcDev.deviceId);
  var serialToPlaceIn = tarProduct.serializable && origiSerial ? origiSerial : null;
  var origiSerialIdx = serialToPlaceIn ? serialToPlaceIn.deviceIds.findIndex(x => x == srcDeviceId) : -1;
  var originalGroups = groupingAllowed ? getGroupsOfDevice(srcDeviceId) : [];

  originalGroups.forEach(function (group) {
    if (!UDevGlobals.devJustChangingInGroup[group.id]) {
      UDevGlobals.devJustChangingInGroup[group.id] = [];
    }
    UDevGlobals.devJustChangingInGroup[group.id].push(devClone);
  });

  var originalMeasurements = getMeasurementsOfDevice(srcDev.deviceId);
  var originalNote = getNote(srcDev.deviceId, "dev");

  var tarPos = uDev.getTopLeftOfDevice_NoDOM(srcDeviceId);
  var tarAngle = srcDev.angle;

  if (forcedPosition) {
    if (forcedPosition === "auto") {
      var adjustedPos = uDev.getAdjustedPositionForDev(srcDev);
      if (adjustedPos) {
        tarPos = adjustedPos.point;
        tarAngle = adjustedPos.angle;
      }
    }
    else if (forcedPosition.x && forcedPosition.y) {
      tarPos = forcedPosition;
    }
  }
  else if (targetSerialParams && 'x' in targetSerialParams) {
    tarPos.x = targetSerialParams.x;
    tarPos.y = targetSerialParams.y;
    tarPos.angle = targetSerialParams.angle;
  }

  const placeableProduct = Object.assign({}, tarProduct, {
    id: productPrefix + targetProductId,
    type: productType,
    parent: 'category_' + (srcDev.category_id ?? 0),
    image: tarProduct.image ?? tarProduct.icon ?? tarProduct.image_url ?? '',
  });

  placeDevice(tarPos.x, tarPos.y, srcDev.roomId, placeableProduct, function (placedDev, resp, tarSer) {
        if (!placedDev) {
          delete UDevGlobals.devIsChangingTo[srcDeviceId];
          delete UDevGlobals.devIsChangingToObj[srcDeviceId];
          promise.resolve(false);
          return;
        }
        if (tarSer && targetSerialParams) {
          PlannerGlobals.plannerHistoryManager.serialIdChanged(targetSerialParams.id, tarSer.id);
        }
        if (placedDev && UDevGlobals.devIsChangingToObj[srcDeviceId]) {
          srcDev.newDeviceId = placedDev.deviceId;
          placedDev.changingFromOther = true;
          plannerHistoryHelper.placeDevIntoAllGroups(placedDev.deviceId, originalGroups, 0, function () {
            placedDev.changingFromOther = false;
            originalGroups.forEach(function (group) {
              UDevGlobals.devJustChangingInGroup[group.id] = UDevGlobals.devJustChangingInGroup[group.id].filter(function (dev) {
                return dev.deviceId !== srcDeviceId;
              });
            });

            removeDevicePure(srcDev.deviceId)
            .always(function () {
              if (placedDev) {
                delete UDevGlobals.devIsChangingTo[srcDeviceId];
                delete UDevGlobals.devIsChangingToObj[srcDeviceId];

                // ikon csere után note szövegének ujraküldése
                // mivel a beépített notok ilyenkor hibásan mentödnek ezt egyenlőre kiveszük
                // if (originalNote && !placedDev.noteId) {
                //     sendDevNoteAuto(placedDev.deviceId, originalNote.text, originalNote.color, function (res) {
                //
                //         if (res) {
                //             plannerHistoryManager.noteIdChanged(originalNote.note_id, res.noteId);
                //         }
                //     });
                // }

                if (serialToPlaceIn) {
                  const newSerialIdx = serialToPlaceIn.deviceIds.findIndex(x => x == placedDev.deviceId);
                  if (newSerialIdx != origiSerialIdx) {
                    serialToPlaceIn.deviceIds.splice(newSerialIdx, 1);
                    serialToPlaceIn.deviceIds.splice(origiSerialIdx, 0, placedDev.deviceId);

                    ajaxSetSerialProps(serialToPlaceIn, true);
                  }
                }

                plannerHistoryHelper.putBackMeasurementConns(originalMeasurements);

                PlannerGlobals.plannerHistoryManager.deviceIdChanged(srcDeviceId, placedDev.deviceId);
                if (!noRedraw) {
                  if (origiSerial && origiSerial.deviceIds.length) {
                    redrawDevice(origiSerial.deviceIds[0]);
                  }
                  else {
                    redrawDevice(srcDeviceId);
                  }
                  redrawDevice(placedDev.deviceId);
                }

                promise.resolve(placedDev, tarSer);
              }
            });
          });
        }
      }, !serialToPlaceIn && (!srcDev.serializable || needToCreateNewSerial),
      serialToPlaceIn, tarAngle, true, true, undefined, undefined,
      targetSerialParams && ('height' in targetSerialParams) ? targetSerialParams : undefined);

  return promise;
}

/**
 *
 * @param {{srcDeviceId: number, targetProductId: number, targetIdIsCustom: boolean, forcedPosition: Point}[]} changeParameters
 * @param {number} idx
 * @param {function} cb
 * @param {function} onProgressCb
 * @param {boolean} disableGrouping
 * @param @param {Object.<number, {id: number, height: number, direction: 'horizontal' | 'vertical', x, y, angle}>} deviceIdToSerialParams
 */
export function chainChangeDevices(changeParameters, idx = 0, cb, onProgressCb, disableGrouping = false, deviceIdToSerialParams = {}) {
  if (changeParameters.length && typeof onProgressCb === "function") {
    onProgressCb(Math.round(idx / changeParameters.length * 100));
  }
  if (idx >= changeParameters.length) {
    redrawGroups();
    if (changeParameters.length) {
      refreshFloorView();
    }
    if (typeof cb === "function") {
      cb(true, deviceIdToSerialParams);
    }
  }
  else {
    var curr = changeParameters[idx];

    changeDevice(curr.srcDeviceId, curr.targetProductId, curr.targetIdIsCustom, curr.forcedPosition, undefined, disableGrouping, deviceIdToSerialParams[curr.srcDeviceId] || null)
    .done(function (placedDev, tarSer) {
      if (tarSer) {
        if (placedDev.deviceId in deviceIdToSerialParams) {
          deviceIdToSerialParams[placedDev.deviceId].id = tarSer.id;
        }
        else {
          deviceIdToSerialParams[placedDev.deviceId] = { id: tarSer.id };
        }
      }
      chainChangeDevices(changeParameters, idx + 1, cb, onProgressCb, disableGrouping, deviceIdToSerialParams);
    })
    .fail(function () {
      if (typeof cb === "function") { cb(false); }
    });
  }
}

export function getTopD3DevForSerial(serialId) {
  const conn = getSerialConnectionForSerialId(serialId);
  if (conn) {
    const props = getSerialConnectionProps(conn.id);
    if (props) {
      return props;
    }
  }

  const serial = getSerialById(serialId);
  if (serial) {
    const serObj = getSerObj(serial);
    if (serObj) {
      return serObj;
    }
  }

  return null;
}

/**
 *
 * @param {number} serialId
 * @param {{x: number, y: number, angle: number, roomId: number}} props
 * @returns
 */
export function setAndSendSerialPosition(serialId, props) {
  const proms = [];

  const serial = getSerialById(serialId);
  if (!serial || !props) { return Promise.resolve(); /* Promise.reject(); */ }
  if (!serial.deviceIds.length) { return Promise.resolve(); }
  const restoreProps = ['x', 'y', 'angle', 'roomId'];
  restoreProps.forEach(prop => {
    if (prop in props) {
      serial[prop] = props[prop];
    }
  });

  serial.deviceIds.forEach(devId => {
    const dev = getDeviceById(devId);
    if (dev) {
      restoreProps.forEach(prop => {
        if (prop in props) {
          dev[prop] = props[prop];
        }
      });
      proms.push(updateDev(dev));
    }
  });

  return Promise.all(proms);
}

/**
 *
 * @param {Product} product
 * @param {Serial} targetSerial
 * @returns {{alone: boolean, targetSerial: Serial | null, connectTo: Serial | null}}
 */
export function getProductTargetSerialStrategy(product, targetSerial) {
  if (!product.serializable) {
    return {
      alone: true,
      targetSerial: null,
      connectTo: null
    };
  }
  else if (!targetSerial) {
    //console.debug('strat: no target serial, placing dev normally');
    return {
      alone: true,
      targetSerial: null,
      connectTo: null
    };
  }
  else {
    const prodDefaultHeight = getSerialHeightForPNID(product.id.replace('product_', ''));
    const conn = getSerialConnectionForSerialId(targetSerial.id);
    const props = conn ? getSerialConnectionProps(conn.id) : null;
    if (props) {
      // TARGET HAS CONNECTION
      const sameHeightSerial = props.serials.find(ser => ser.height == prodDefaultHeight);
      if (sameHeightSerial) {
        //console.debug('strat: target is connected and has same height serial as dev needs');
        return {
          alone: false,
          targetSerial: sameHeightSerial,
          connectTo: null
        }
      }
      else {
        //console.debug('strat: target is connected and has no exact height serial as needed. placing on dropped target');
        return {
          alone: false,
          targetSerial: targetSerial,
          connectTo: null
        };
      }
    }
    else {
      // NO CONNECTION OF TARGET
      const targetHeight = targetSerial.height;
      const minDistCM = isPlannerMetric() ? 12 : inchToCm(5);
      if (targetHeight == prodDefaultHeight || Math.abs(targetHeight - prodDefaultHeight) < minDistCM) {
        //console.debug('strat: target serial height is similar to dropped dev default height, placing dev in it');
        return {
          alone: false,
          targetSerial: targetSerial,
          connectTo: null
        };
      }
      else {
        //console.debug('strat: target serial is diff height than dragged dev, creating connection');
        return {
          alone: true,
          targetSerial: null,
          connectTo: targetSerial
        };
      }
    }
  }
}

export const uDevDOM = {
  devicesOfD3Ds: function (dArr) {
    return dArr.reduce(function (p, c) {
      return p.concat(uDevDOM.devicesOfD3D(c));
    }, []);
  },
  polygonIntersectsAnyOutdoorDev: function (poly) {
    var segments = uMath.segmentsFromPointArray(poly);
    for (var segment of segments) {
      if (uDevDOM.segmentIntersectsAnyOutdoorDev(segment)) {
        return true;
      }
    }
    return false;
  },
  polygonIntersectsAnyDev: poly => {
    const segments = uMath.segmentsFromPointArray(poly);
    for (const segment of segments) {
      if (uDevDOM.segmentIntersectsAnyDev(segment)) {
        return true;
      }
    }
    return false;
  },
  /**
     *
     * @param {number[]} PNIDs
     */
    serialPNIDsToDevices: function (PNIDs) {
      var serialDevs = [];
      var pnidCount = {};
      PNIDs.forEach(function (pnid) {
        if (pnid in pnidCount) {
          pnidCount[pnid]++;
        }
        else {
          pnidCount[pnid] = 1;
        }
      });
      for (let pnid in pnidCount) {
        let dev = deviceProvider.getDeviceByProductNameId(pnid)
        if (!dev) {
          continue;
        }
        dev = $.extend(true, {}, dev);
        if (isDevMergedWithSerials(pnid)) {
          dev.qty = pnidCount[pnid];
          serialDevs.push(dev);
        }
        else {
          dev.qty = 1;
          for (var i = 0; i < pnidCount[pnid]; i++) {
            serialDevs.push(dev);
          }
        }
      }
      return serialDevs;
    },
  getCenterOfSerial: function (serialId) {
      var ser = getSerialD(serialId);
      if (!ser) {
        return false;
      }
      return P_numtoxy(getSerialCenterPos(ser));
    },
  getCenterOfDevice: function (deviceId) {
      var dev = getDeviceById(deviceId);
      if (!dev) {
        return false;
      }
      return P_numtoxy(getDevicePositionCenter(dev));
    },
  /**
     * get all the outdoor devices that are inside (or partially inside) the outer border
     * @returns {Device[]}
     */
    getInvalidOutdoorDevs: function () {
      var invalids = [];
      uDevDOM.getOutdoorDevsD3Style().forEach(function (d3Data) {
        var devDat = dataFromDeviceD(d3Data);
        if (!doesDeviceFitRoom(devDat.roomId, devDat.point, devDat.rotation, devDat.serialLength, devDat.serialRows)) {
          d3Data.devices.forEach(function (dev) {
            invalids.push(dev);
          });
        }
      });
      return invalids;
    },
  getDeviceD3Group: function (deviceId) {
      var ser = getSerialOfDeviceId(deviceId);
      if (ser) {
        const conn = getSerialConnectionForSerialId(ser.id);
        if (conn) {
          return getDevicesD3Style().find(function (d3d) { return d3d.connId == conn.id; });
        }
        return getSerialD(ser.id);
      }
      else {
        return getDevicesD3Style().find(function (dev) { return dev.devices[0].deviceId === deviceId; });
      }
    },
  /**
     * @returns {D3Device[]}
     */
    getOutdoorDevsD3Style: function () {
      return getDevicesD3Style().filter(function (dev) {
        return dev.roomId == uDev.OUTDOORS_ROOM_ID;
      });
    },
  getMovedDevsForRoomModify: roomId => {
      const allD3Devs = getDevicesD3Style();
      /**
       * @type {D3Device[]}
       */
      const removedD3Devs = [];
      /**
       * @type {D3Device[]}
       */
      const moveFromRoomToUnassignedD3Devs = [];
      /**
       * @type {D3Device[]}
       */
      const moveFromUnassignedToRoomD3Devs = [];
  
      const defaultRoomId = uDev.outerBorderExists() && isRoomOutside(getRoomById(roomId), PlannerGlobals.outerBorder) ? uDev.OUTDOORS_ROOM_ID : uDev.UNASSIGNED_ROOM_ID;
      allD3Devs.forEach(d3Dev => {
  
        const params = dataFromDeviceD(d3Dev);
  
        if (d3Dev.roomId == roomId) {
          if (!doesDeviceFitRoom(roomId, params.point, params.rotation, params.serialLength, params.serialRows)) {
            if (doesDeviceFitRoom(defaultRoomId, params.point, params.rotation, params.serialLength, params.serialRows)) {
              moveFromRoomToUnassignedD3Devs.push(d3Dev);
            }
            else {
              removedD3Devs.push(d3Dev);
            }
          }
        }
        else if (d3Dev.roomId == defaultRoomId || d3Dev.roomId == uDev.OUTDOORS_ROOM_ID) {
          if (doesDeviceFitRoom(roomId, params.point, params.rotation, params.serialLength, params.serialRows)) {
            moveFromUnassignedToRoomD3Devs.push(d3Dev);
          }
        }
      });
  
      if (removedD3Devs.length) {
        console.debug(removedD3Devs, 'wanted to remove d3devs but removing by room/outerwall modify is disabled, so this is a potential bug');
      }
  
      return {
        removedD3Devs: [],
        moveFromRoomToUnassignedD3Devs,
        moveFromUnassignedToRoomD3Devs
      };
    },
  refreshDevRoomsForRoomModify: (roomId, callback) => {
      const {
        removedD3Devs,
        moveFromRoomToUnassignedD3Devs,
        moveFromUnassignedToRoomD3Devs } = uDevDOM.getMovedDevsForRoomModify(roomId);
  
      const defaultRoomId = uDev.outerBorderExists() && isRoomOutside(getRoomById(roomId), PlannerGlobals.outerBorder) ? uDev.OUTDOORS_ROOM_ID : uDev.UNASSIGNED_ROOM_ID;
  
      const devsToRemove = uDevDOM.devicesOfD3Ds(removedD3Devs);
  
      const removedGroups = deepCopy(getDistinctGroupsOfDevs(devsToRemove));
      processDeletedD3Devs(removedD3Devs);
      const removedSerConns = deepCopy(getDistinctSerialConnectionsOfDevs(devsToRemove));
  
      const fromOutToUnDevs = uDevDOM.devicesOfD3Ds(moveFromRoomToUnassignedD3Devs);
      const fromUnToOutdevs = uDevDOM.devicesOfD3Ds(moveFromUnassignedToRoomD3Devs);
  
      moveEnframedDevsToRoom(fromOutToUnDevs, defaultRoomId)
      .then(() => moveEnframedDevsToRoom(fromUnToOutdevs, roomId))
      .then(() => removeDevices(devsToRemove).done(function () {
        redrawDevices();
        refreshFloorView();
        if (typeof callback === "function") {
          callback(removedD3Devs, removedGroups, removedSerConns);
        }
      }));
  
      return {
        removedD3Devs: [],
        removedGroups,
        removedSerConns,
        enframedD3Devs: moveFromUnassignedToRoomD3Devs,
        leftOutD3Devs: moveFromRoomToUnassignedD3Devs
      }
    },
  getMovedDevsForOuterwallModify: () => {
      const allD3Devs = getDevicesD3Style();
      /**
       * @type {D3Device[]}
       */
      const removedD3Devs = [];
      /**
       * @type {D3Device[]}
       */
      const moveFromOutdoorToUnassignedD3Devs = [];
      /**
       * @type {D3Device[]}
       */
      const moveFromUnassignedToOutdoorD3Devs = [];
  
      allD3Devs.forEach(d3Dev => {
        const params = dataFromDeviceD(d3Dev);
  
        if (d3Dev.roomId == uDev.OUTDOORS_ROOM_ID) {
          if (!doesDeviceFitRoom(uDev.OUTDOORS_ROOM_ID, params.point, params.rotation, params.serialLength, params.serialRows)) {
            if (doesDeviceFitRoom(uDev.UNASSIGNED_ROOM_ID, params.point, params.rotation, params.serialLength, params.serialRows)) {
              moveFromOutdoorToUnassignedD3Devs.push(d3Dev);
            }
            else {
              removedD3Devs.push(d3Dev);
            }
          }
        }
        else if (d3Dev.roomId == uDev.UNASSIGNED_ROOM_ID) {
          if (!doesDeviceFitRoom(uDev.UNASSIGNED_ROOM_ID, params.point, params.rotation, params.serialLength, params.serialRows)) {
            if (doesDeviceFitRoom(uDev.OUTDOORS_ROOM_ID, params.point, params.rotation, params.serialLength, params.serialRows)) {
              moveFromUnassignedToOutdoorD3Devs.push(d3Dev);
            }
            else {
              removedD3Devs.push(d3Dev);
            }
          }
        }
      });
  
      if (removedD3Devs.length) {
        console.debug(removedD3Devs, 'wanted to remove d3devs but removing by room/outerwall modify is disabled, so this is a potential bug');
      }
  
      return {
        removedD3Devs: [],
        moveFromOutdoorToUnassignedD3Devs,
        moveFromUnassignedToOutdoorD3Devs
      };
    },
  refreshDevRoomsForOuterBorderModify: (callback) => {
      const {
        removedD3Devs,
        moveFromOutdoorToUnassignedD3Devs,
        moveFromUnassignedToOutdoorD3Devs
      } = uDevDOM.getMovedDevsForOuterwallModify();
  
      const devsToRemove = uDevDOM.devicesOfD3Ds(removedD3Devs);
  
      const removedGroups = deepCopy(getDistinctGroupsOfDevs(devsToRemove));
      processDeletedD3Devs(removedD3Devs);
      const removedSerConns = deepCopy(getDistinctSerialConnectionsOfDevs(devsToRemove));
  
      const fromOutToUnDevs = uDevDOM.devicesOfD3Ds(moveFromOutdoorToUnassignedD3Devs);
      const fromUnToOutdevs = uDevDOM.devicesOfD3Ds(moveFromUnassignedToOutdoorD3Devs);
  
      moveEnframedDevsToRoom(fromOutToUnDevs, uDev.UNASSIGNED_ROOM_ID)
      .then(() => moveEnframedDevsToRoom(fromUnToOutdevs, uDev.OUTDOORS_ROOM_ID))
      .then(() => removeDevices(devsToRemove).done(function () {
        redrawDevices();
        refreshFloorView();
        if (typeof callback === "function") {
          callback(removedD3Devs, removedGroups, removedSerConns);
        }
      }));
  
      return {
        removedD3Devs: [],
        removedGroups,
        removedSerConns,
        enframedD3Devs: moveFromUnassignedToOutdoorD3Devs,
        leftOutD3Devs: moveFromOutdoorToUnassignedD3Devs
      };
    },
  /**
     * this removes all the outdoor devices that are inside (or partially inside) the outer border
     */
    deleteInvalidOutdoorDevs: function (callback) {
      var removedD3Devs = [];
  
      uDevDOM.getOutdoorDevsD3Style().forEach(function (d3Dev) {
        var devDat = dataFromDeviceD(d3Dev);
        if (!doesDeviceFitRoom(devDat.roomId, devDat.point, devDat.rotation, devDat.serialLength, devDat.serialRows)) {
          removedD3Devs.push(d3Dev);
        }
      });
  
      var devs = uDevDOM.devicesOfD3Ds(removedD3Devs);
  
      var removedGroups = deepCopy(getDistinctGroupsOfDevs(devs));
      processDeletedD3Devs(removedD3Devs);
      var removedSerConns = deepCopy(getDistinctSerialConnectionsOfDevs(devs));
  
      removeDevices(devs).done(function () {
        redrawDevices();
        if (typeof callback === "function") {
          callback(removedD3Devs, removedGroups, removedSerConns);
        }
      });
    },
  /**
     * delete devices locally that are outdoors
     * this is used when deleting the outer border
     * @deprecated dont use this, we need to regroup outdoor devs to unassigned when deleting outer border
     */
    deleteOutdoorDevs: function (callback) {
      var d3DevsToDel = getDevicesD3Style().filter(function (d3d) {
        return d3d.roomId === uDev.OUTDOORS_ROOM_ID;
      });
  
      const devs = uDevDOM.devicesOfD3Ds(d3DevsToDel);
  
      var deletedGrps = deepCopy(getDistinctGroupsOfDevs(devs));
      processDeletedD3Devs(d3DevsToDel);
      var deletedSerConns = deepCopy(getDistinctSerialConnectionsOfDevs(devs));
  
      removeDevices(devs).done(function () {
        if (typeof callback === "function") {
          callback(d3DevsToDel, deletedGrps, deletedSerConns);
        }
      });
    },
  makeOutdoorDevsUnassigned: function () {
      var d3DevsToAssign = getDevicesD3Style().filter(function (d3d) {
        return d3d.roomId === uDev.OUTDOORS_ROOM_ID;
      });
  
      const devs = uDevDOM.devicesOfD3Ds(d3DevsToAssign);
      /* const devs = devices.filter(dev => dev.roomId == uDev.OUTDOORS_ROOM_ID); */
  
      devs.forEach(dev => dev.roomId = uDev.UNASSIGNED_ROOM_ID);
  
      return Promise.all(devs.map(dev => updateDev(dev))).then(() => d3DevsToAssign);
    },
  getD3DevsContainedByPoly: function (poly) {
      var containedDevs = [];
  
      for (var d3Dev of getDevicesD3Style()) {
        var corners = getRotatedSerialCorners(d3Dev);
        var someCouldFit = corners.some(function (corner) { return d3.polygonContains(poly, corner) });
        var allCouldFit = corners.every(function (corner) { return d3.polygonContains(poly, corner) });
        if (someCouldFit && !allCouldFit) {
          return false;
        }
        else if (allCouldFit) {
          uDevDOM.devicesOfD3D(d3Dev).forEach(function (dev) {
            containedDevs.push(dev);
          });
        }
      }
  
      return containedDevs;
    },
  /**
     * @deprecated indoor devs can be enframed now too, so don't use this
     * @param {[number, number][]} poly
     * @returns {Device[] | false}
     */
    getOutdoorDevsContainedByPoly: function (poly) {
      var containedDevs = [];
  
      for (var outdoorDevD3 of uDevDOM.getOutdoorDevsD3Style()) {
        var corners = getRotatedSerialCorners(outdoorDevD3);
        var someCouldFit = corners.some(function (corner) { return d3.polygonContains(poly, corner) });
        var allCouldFit = corners.every(function (corner) { return d3.polygonContains(poly, corner) });
        if (someCouldFit && !allCouldFit) {
          return false;
        }
        else if (allCouldFit) {
          uDevDOM.devicesOfD3D(outdoorDevD3).forEach(function (dev) {
            containedDevs.push(dev);
          });
        }
      }
  
      return containedDevs;
    },
  /**
     *
     * @param {D3Device} d
     * @returns {Device[]}
     */
    devicesOfD3D: function (d) {
      if (d.id) {
        var ser = getSerialById(d.id);
        if (!ser) {
          return false;
        }
        return ser.deviceIds.map(getDeviceById);
      }
      else if (d.connId) {
        return d.serials.reduce((arr, ser) => {
          return arr.concat(ser.deviceIds.map(getDeviceById));
        }, []);
      }
      else {
        /**
         * @type {Device}
         */
        var dev = d.devices[0];
        if (!canBeDevMerged(dev)) {
          return [d.devices[0]];
        }
        else {
          return PlannerGlobals.devices.filter(function (cd) {
            return cd.roomId === dev.roomId && cd.product_name_id === dev.product_name_id && cd.deviceId === dev.deviceId;
          });
        }
      }
    },
  /**
     *
     * @param {Segment} segment
     * @returns {boolean}
     */
    segmentIntersectsAnyOutdoorDev: function (segment) {
      for (var dev of uDevDOM.getOutdoorDevsD3Style()) {
        var rectPts = d3DevRotatedRectPolygon(dev);
        var intersect = uMath.segmentPolygonIntersection(segment, rectPts);
        if (intersect) {
          return true;
        }
      }
      return false;
    },
  segmentIntersectsAnyDev: segment => {
      for (var dev of getDevicesD3Style()) {
        var rectPts = d3DevRotatedRectPolygon(dev);
        var intersect = uMath.segmentPolygonIntersection(segment, rectPts);
        if (intersect) {
          return true;
        }
      }
      return false;
    },
  postItAjax: {
      /**
       *
       * @param {{x: number, y: number, note: string, color: string, floor_id: number, note_type: number, plan_object_id: number}} postit
       * @param {function} sCallback
       * @param {function} eCallback
       */
      sendNew: function (postit, sCallback, eCallback) {
        getAuthHeader(function (headers) {
          $.ajax({
            headers,
            url: ROOT_URI + '/postits',
            method: 'POST',
            data: {
              x: postit.x,
              y: postit.y,
              color: postit.color,
              note: postit.note,
              floor_id: postit.floor_id,
              plan_object_id: postit.plan_object_id,
              note_type: postit.note_type,
            },
            success: sCallback,
            error: eCallback
          });
        });
      },
      modify: function (id, color, note, sCallback, eCallback) {
        getAuthHeader(function (headers) {
          $.ajax({
            headers,
            url: ROOT_URI + '/postits',
            method: 'PUT',
            data: {
              post_it_id: id,
              color: color,
              note: note,
            },
            success: sCallback,
            error: eCallback
          });
        });
      },
      modifyDrag: function (id, x, y, sCallback, eCallback) {
        getAuthHeader(function (headers) {
          $.ajax({
            headers,
            url: ROOT_URI + '/postits',
            method: 'PUT',
            data: {
              post_it_id: id,
              x: x,
              y: y
            },
            success: sCallback,
            error: eCallback
          });
        });
      },
      delete: function (id, sCallback, eCallback) {
        getAuthHeader(function (headers) {
          $.ajax({
            headers,
            url: ROOT_URI + '/postits',
            method: 'DELETE',
            data: {
              post_it_id: id,
            },
            success: sCallback,
            error: eCallback
          });
        });
      }
    }
};
